// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/solana-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TokenStandard = {
    ProgrammableNonFungible: 'ProgrammableNonFungible',
    NonFungible: 'NonFungible',
    Fungible: 'Fungible',
    FungibleAsset: 'FungibleAsset',
    NonFungibleEdition: 'NonFungibleEdition',
    UnknownStandard: 'UnknownStandard'
} as const;
export type TokenStandard = typeof TokenStandard[keyof typeof TokenStandard];


export function TokenStandardFromJSON(json: any): TokenStandard {
    return TokenStandardFromJSONTyped(json, false);
}

export function TokenStandardFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenStandard {
    return json as TokenStandard;
}

export function TokenStandardToJSON(value?: TokenStandard | null): any {
    return value as any;
}

